<template>
    <div class="insertSharedAccordionDetailModal">
        <button @click="showModal" v-if="accordionDetail" class="openModalButton" :disabled="!isActive">Apply Shared Detail</button>
        <div v-if="modalActive" class="modal" @click.self="hideModal">
            <div class="modalForm">
                <h2 class="modalTitle">Apply Shared Detail</h2>
                <div class="searchContainer">
                    <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
                    <div class="formRow">
                        <span class="inputTitle">Tags: </span>
                        <Multiselect v-if="tags" 
                                    v-model="selectedTags"
                                    :options="tags"
                                    track-by="name"
                                    label="name"
                                    placeholder="Type to search"
                                    open-direction="bottom"
                                    :multiple="true"
                                    :searchable="true"></Multiselect>
                    </div>
                </div>
                <hr />
                <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
                    :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc', pageSize: '10'}" />
                <div class="formRow" style="justify-content: space-between;">
                    <ItemModal buttonHtml="<span class=&quot;openModalButton&quot;>Add New Shared Detail</span>" :refreshItemsFunction="onModalReturn" ></ItemModal>
                    <button @click="hideModal" class="cancelButton">Cancel</button>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ListingTable from '@/components/shared/ListingTable.vue';
import Multiselect from 'vue-multiselect';
import ItemModal from '@/components/sharedAccordionDetail/ItemModal.vue';

export default {
    name: 'InsertSharedAccordionDetail',
    components: { ListingTable, Multiselect, ItemModal },
    props: {
        accordionDetail: Object,
        isActive: Boolean,
        tags: Array,
        saveAccordionDetail: Function
    },
    data: function() {
        return {
            modalActive: false,
            searchText: '',
            selectedTags: '',
            sharedAccordionDetails: [],
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Description",
                    width: "60%",
                    fieldName: "description"
                },
                {
                    headerDisplayName: "Tags",
                    width: "30%",
                    fieldName: "tags"
                }
            ],
            actionMappings: {
                onLoadData: this.getSharedAccordions,
                onSelect: this.onDetailSelect
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "description",
                    value: this.searchText
                });

            if(this.selectedTags != '') {
                criteria.push( {
                    dataType: "StringArray",
                    fieldName: "tags",
                    value: this.selectedTags.map(tag => tag.name)
                });

            }
            return criteria;
        }
    },
    methods: {
        showModal: async function() {
            this.modalActive = true;
            this.componentKey++;
        },
        hideModal: function() {
            this.searchText = '';
            this.selectedTags = [];
            this.modalActive = false;
        },
        getSharedAccordions: async function() {
            return await data.getSharedDetails('');
        },
        onDetailSelect: async function(sd) {
            const sharedDet = await data.getSharedDetail(sd.id);
            await this.saveAccordionDetail(sharedDet, this.accordionDetail);
            this.hideModal();
        },
        onModalReturn() {
            this.componentKey++;
        }
    }

}
</script>

<style scoped>
    .openModalButton {
        background-color: #036991;
        color: white;
        height: 40px;
        width: 200px;
        border-radius: 6px;
        border-color: #036991;
        cursor: pointer;
        font-size: 16px;
        margin: 10px 0 0 16px;
    }
    :deep(.openModalButton) {
        background-color: #036991;
        color: white;
        height: 40px;
        width: 200px;
        border-radius: 6px;
        border-color: #036991;
        cursor: pointer;
        font-size: 16px;
    }
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        padding: 100px 0 0 0;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .modalForm {
        position: relative;
        border: 1px solid lightgray;
        background-color: white;
        width: 800px;
        padding: 20px;
        text-align: left;
        max-height: calc(100vh - 210px);
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 20;
    }
    .modalTitle {
        width: 100%;
        text-align: center;
    }
    #addMediaPropertyModal {
        display: inline-block;
    }
    .cancelButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        cursor: pointer;
        font-size: 16px;
    }
</style>